import { ILogger } from "./ILogger";

export class NullLogger implements ILogger {
    public warning(): void {
        // empty implementation
    }

    public error(): void {
        // empty implementation
    }

    public log(): void {
        // empty implementation
    }

    public verbose(): void {
        // empty implementation
    }

    public withPrefix(): ILogger {
        // empty implementation
        return this;
    }
}

let staticLoggerInstance: ILogger = new NullLogger();

export function setLogger(logger: ILogger): void {
    staticLoggerInstance = logger;
}

export function getLogger(): ILogger {
    return staticLoggerInstance;
}
